import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=6714449b&lang=pug&"
import script from "./WordCloud.vue?vue&type=script&lang=ts&"
export * from "./WordCloud.vue?vue&type=script&lang=ts&"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=6714449b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports